import jwtDecode from "jwt-decode";

import history from "./history";
import ApiService from "../services/globalBibleApi";

const {
  REACT_APP_COGNITO_DOMAIN = "",
  REACT_APP_COGNITO_APP_CLIENT_ID = "",
  REACT_APP_COGNITO_CALLBACK_URL = ""
} = process.env;

export default class Auth {
  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.isAdmin = this.isAdmin.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  login() {
    const hostedUIUrl = `${REACT_APP_COGNITO_DOMAIN}/login?client_id=${REACT_APP_COGNITO_APP_CLIENT_ID}&response_type=token&redirect_uri=${REACT_APP_COGNITO_CALLBACK_URL}&scope=aws.cognito.signin.user.admin+email+openid+profile`;
    window.location.replace(hostedUIUrl);
  }

  // eslint-disable-next-line class-methods-use-this
  handleAuthentication(props) {
    const urlParams = new URLSearchParams(props.location.hash.slice(1));

    const idToken = urlParams.get("id_token");
    if (!idToken) history.push("/"); // force user to log in again, something went wrong
    localStorage.setItem("id_token", idToken);

    const accessToken = urlParams.get("access_token");
    localStorage.setItem("access_token", accessToken);

    const expiresIn = urlParams.get("expires_in");
    const expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime());
    localStorage.setItem("expires_at", expiresAt);

    const decodedIdToken = jwtDecode(idToken);
    const roles = decodedIdToken["cognito:groups"] ? decodedIdToken["cognito:groups"].join(",") : "";
    localStorage.setItem("roles", roles);

    ApiService.setAuthHeader(`Bearer ${idToken}`);

    history.replace("/");
  }

  // eslint-disable-next-line class-methods-use-this
  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("roles");

    // navigate to the home route
    history.replace("/");
  }

  // eslint-disable-next-line class-methods-use-this
  isAdmin() {
    const scope = localStorage.getItem("roles");
    if (scope && scope.split(",").indexOf("admin:global") !== -1) {
      return true;
    }
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    const isAuthenticated = new Date().getTime() < expiresAt;

    if (isAuthenticated) {
      const idToken = localStorage.getItem("id_token");
      ApiService.setAuthHeader(`Bearer ${idToken}`);
    }

    return isAuthenticated;
  }
}
